import React from 'react';
import { useSelector } from 'react-redux';
import { useOptions } from '../../hooks/useOptions';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { showOrionPerformanceSelector } from '../../../CommonSelectors/CommonAreaSelector';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';

export const GrossOfFeeIcon = () => {
  const { showGrossOfFeeDisclaimer } = useOptions();
  const isPerformanceOn = useSelector(showOrionPerformanceSelector);
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (!showGrossOfFeeDisclaimer || !isPerformanceOn || isEmbeddedMobile) {
    return null;
  }

  return <Icon className="far fa-info-circle" color="neutral.400" fontSize="body" ml="8" />;
};
